import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import Button from '../../../../../../Button';
import InsertDialog from '../../../Insert/InsertDialog';
import { useDashboardDispatch } from '../../../context/dashboardContext';

var EditDataButton = function EditDataButton(_ref) {
  var children = _ref.children,
      widget = _ref.widget,
      cube = _ref.cube;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      dialog = _useState2[0],
      setDialog = _useState2[1];

  var dashboardDispatch = useDashboardDispatch();

  var handleButtonClick = function handleButtonClick() {
    switch (widget.elementName) {
      case 'pieChart':
      case 'columnChart':
      case 'barChart':
      case 'lineChart':
        setDialog({
          actionType: 'edit_chart',
          widgetData: {
            id: widget.id,
            category: cube.axes[0],
            series: widget.series.map(function (series) {
              var source = series.source,
                  rest = _objectWithoutProperties(series, ["source"]);

              return _objectSpread({}, rest, {
                id: source,
                value: cube.measures.find(function (measure) {
                  return measure.id === source;
                })
              });
            })
          }
        });
        break;

      case 'table':
        setDialog({
          actionType: 'edit_table',
          widgetData: {
            id: widget.id,
            columns: widget.columns.map(function (column) {
              return {
                id: column.source,
                title: column.title,
                format: column.format,
                align: column.align,
                value: cube.axes.concat(cube.measures).find(function (dimension) {
                  return dimension.id === column.source;
                })
              };
            })
          }
        });
        break;

      case 'circularGauge':
      case 'liniarGauge':
        setDialog({
          actionType: 'edit_gauge',
          widgetData: {
            id: widget.id,
            value: cube.measures[0],
            startValue: widget.startValue,
            endValue: widget.endValue,
            majorTickCount: widget.majorTickCount
          }
        });
        break;

      default:
        throw new Error('Unsupported widget type.');
    }
  };

  return React.createElement(React.Fragment, null, React.createElement(Button, {
    size: "small",
    color: "inherit",
    variant: "outlined",
    onClick: handleButtonClick
  }, children), dialog !== null && React.createElement(InsertDialog, {
    type: widget.elementName,
    widgetData: dialog.widgetData,
    onSubmit: function onSubmit(widgetData) {
      {
        dashboardDispatch({
          type: dialog.actionType,
          payload: _objectSpread({
            type: widget.elementName
          }, widgetData)
        });
      }
    },
    onClose: function onClose() {
      return setDialog(null);
    }
  }));
};

export default EditDataButton;